/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the option for how row selection is animated.
 */
export var RowHoverAnimationMode = /*@__PURE__*/ (function (RowHoverAnimationMode) {
    /**
     * The correct animation mode is automatically selected.
     */
    RowHoverAnimationMode[RowHoverAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    RowHoverAnimationMode[RowHoverAnimationMode["None"] = 1] = "None";
    /**
     * The selection color and the normal background color are blended between.
     */
    RowHoverAnimationMode[RowHoverAnimationMode["ColorBlend"] = 2] = "ColorBlend";
    return RowHoverAnimationMode;
})({});
/**
 * @hidden
 */
export var RowHoverAnimationMode_$type = /*@__PURE__*/ markEnum('RowHoverAnimationMode', 'Auto,0|None,1|ColorBlend,2');
//# sourceMappingURL=RowHoverAnimationMode.js.map
